import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { PermissionsForRequisitions} from "../shared/models/user.model";

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {

  private requisitionsPermissions: BehaviorSubject<PermissionsForRequisitions | null> = new BehaviorSubject<PermissionsForRequisitions | null> (null);

  requisitionsPermissions$: Observable<PermissionsForRequisitions | null> = this.requisitionsPermissions.asObservable();

  get userPermissionsInRequisitions(): PermissionsForRequisitions | null {
    return this.requisitionsPermissions.value;
  }

  setPermissions(permissions: PermissionsForRequisitions): void {
    this.requisitionsPermissions.next(permissions);
  }

  logout(): void {
    this.requisitionsPermissions.next(null);
  }
}
